module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kanto-1-d15b1fa7a52d194772a62c54a4773d72.png";